import { InsertFailedEntryInBetSlip } from '../actions/entries';
import { SubmitStakeFailure } from '../actions/submission';
import { StakeErrorCode, SubmissionState, TypeOfError } from '../constants';
import { EntryError, EntryLimits, RecordOfBetInfoType } from '../records';

// ---

type SetupError = SubmitStakeFailure['error'] | InsertFailedEntryInBetSlip['error'];
type SetupPayload = SubmitStakeFailure['payload'] | InsertFailedEntryInBetSlip['payload'];

/**
 * Setup bet entry error and the appropriate submission state.
 */
export function setupEntryError(
  entry: RecordOfBetInfoType,
  error: SetupError,
  payload: SetupPayload,
): RecordOfBetInfoType {
  const limits = EntryLimits(error.limits);

  switch (error.status) {
    case StakeErrorCode.BID_DECLINED:
      const betError = payload.betErrors?.find((error) => error.betId === entry.id);
      const matchError = payload.matchErrors?.find((error) => error.matchId === entry.matchId);

      let code: number = error.status;
      let type = TypeOfError.GENERAL;

      if (betError) {
        code = betError.code;
        type = TypeOfError.BET;
      }
      else if (matchError) {
        code = matchError.code;
        type = TypeOfError.MATCH;
      }

      return entry.set('submission', SubmissionState.REJECTED).set(
        'error',
        EntryError({ code, type, limits }),
      );

    case StakeErrorCode.BET_PRICE_CHANGED: {
      const code: number = error.status;
      const type = TypeOfError.GENERAL;
      const rejectReason = error.rejectReason;

      return entry.set('submission', SubmissionState.REJECTED).set(
        'error',
        EntryError({ code, type, limits, rejectReason }),
      );
    }

    case StakeErrorCode.INTERNAL_SYSTEM_ERROR:
    default:
      return entry.set('submission', SubmissionState.FAILED).set(
        'error',
        EntryError({
          code: error.status,
          type: TypeOfError.GENERAL,
          limits,
        }),
      );
  }
}
